export default [
  {
    name: "name",
    title: 'Name',
    width: "60%",
    sortField: "name",
    formatter(value) {
      if (value) {
        return value;
      }else{
        return '--';
      }
    }
  },
  {
    name: "email",
    title: 'Email',
    width: "10%",
    sortField: "email",
    formatter(value) {
      if (value) {
        return value;
      }else{
        return '--';
      }
    }
  },
  {
    name: "phone",
    title: 'Phone Number',
    width: "10%",
    sortField: "phone",
    formatter(value) {
      if (value) {
        return value;
      }else{
        return '--';
      }
    }
  }
]